<p><span><span style="color: #404040;"><span><span lang="en-GB"><strong>Conversion rate:</strong></span></span></span></span></p>
<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >If YTD is selected: Target for the Conversion rate p.m. for the current year (=target for annual Conversion rate / 12). Else:
              Target for annual conversion rate in the year of the selected timeframe.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"><span><span lang="en-GB"><strong>Actual</strong></span></span></span><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: If YTD is selected: Actual average conversion rate p.m. (based on all months YTD). Else: Conversion rate p.a. in the
              selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p>
  <span
    ><span style="color: #7f7f7f;"
      ><span><span lang="en-GB"><em><span style="text-decoration: underline;">Calculation of the Conversion rate</span></em></span></span
      ></span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"
          ><em>: Total number of new customers in timeframe / Total number of all leads open within the reporting timeframe</em></span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB"><br /><br /></p>
<p><span><span style="color: #404040;"><span><span lang="en-GB"><strong>Cow Acquisition Cost:</strong></span></span></span></span></p>
<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span><span lang="en-GB">Target for total cost of acquisition per cow in the year of the selected timeframe</span></span></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >Actual: Actual cost of acquisition per cow YTD (if timeframe = current year YTD) or in the full year (if a previous year is
              selected as reporting timeframe)</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p>
  <span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"><em><span style="text-decoration: underline;">Calculation of the Cow Acquisition Cost</span></em></span></span
      ></span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"
          ><em
            >:Total cost of acquisition (marketing and sales costs) within timeframe (at day level) / total number of new boluses of new
            customers within same timeframe</em
          ></span
        ></span
      ></span
    ></span
  >
</p>
<p>&nbsp;</p>
<p><span><span style="color: #404040;"><span><span lang="en-GB">Chart Conversion rate:</span></span></span></span></p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAHCAYAAACC5PR5AAAAMElEQVR4nGM5/u6PxcE3f+wZBgFgOfDmj0PltR/tA+0QEGAZaAcgg1HH4AKjjsEFAF6kC6Qct3g1AAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Target for conversion rate p.m.</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNxjQ/8z4AHsOCTHFVAggIA4psCIYbRm1MAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Conversion rate per quarter / per half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAHCAYAAABtJp9HAAAAeklEQVR4nGO5duemxaUbV+0ZsABnS7ulIkLCT9DFf//5zb5u55YCbHrkpWWvWRiYbMYmd+LCGd+HTx9rYZNjuXjjisO81UvasUlqq2ocxeaQX79/c8xdvbgDmx4nC9tluBxy4MThiH0nDkdhdQg2wYEAow5BB6MOQQcAU2kqhl/P6ZkAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Average conversion rate per quarter / per half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Conversion rate per quarter/ per half-year in previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAHCAYAAABkzT89AAAAsUlEQVR4nGP5+PGjxYcPH+wZsABRUdE1nJycd7HJPXv2LPPv3788zMzMH5HFgfwv4uLiy7Dp+f79u8r79++dYHwWFpZPjIyMf0Fsbm7uy1xcXDfgckBHOdy7d68dm0FAxVdwOezhw4cVP3/+lEMXZ2dnf4TLYZ8+fTK7devWTGxySkpKlXJych1wh2FTNBjA8HPYv3//uKjpEHRAtsP+///PSk2HwDIBDAyaqATlZmQ+AG19OzWf1OxdAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Average conversion rate per quarter / per half-year in prev. year</span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p><span><span style="color: #404040;"><span><span lang="en-GB">Chart Cow Acquisition cost:</span></span></span></span></p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAHCAYAAACC5PR5AAAAMElEQVR4nGM5/u6PxcE3f+wZBgFgOfDmj0PltR/tA+0QEGAZaAcgg1HH4AKjjsEFAF6kC6Qct3g1AAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Target for cow acquisition cost in selected year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img style="height:12px; background-color: #AFC5B9;" />&nbsp; &nbsp; Cow acquisition cost in quarter/half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAHCAYAAAB3Gn/JAAABBElEQVR4nGP5+esXx69fPzkZkMCXb18F/jMwMIoKCj9hYWH5xYAGgHo4Hz17rIUs9u/fP+av37/zSYtL3BEXEXuArgcEzl654Pb1+zd+ZLHfv3+zs7Gy/bA1tVyDTc+lG1ftr9+9ZYEuzrJu1+aCeauXtGPTNLOlX09RRv4yuvizV89VshtKz2DTE+kb3JYYHF2NTW7WioU995881EUXB9mBy+Hnrl50XbZ5DYZ5LNgUUwL+//vPRE3zODg4vmATJ8vh7Kxs3ylzDir48/cPG6l6yHI4CwsrRrqnBPxEy2NEuQGf5I+fP7nJdw4mYGNl/UEts/A6/O/fv1TNA6ysrD+pZRYAYaxbv9loRFUAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Average cow acquisition cost YTD (or p.a., if full year is selected)</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Cow acquisition cost in quarter/half-year in previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p style="margin-bottom:10px;">
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAHCAYAAACcLcTKAAAAsklEQVR4nGP5/PmzwadPn8wYsAAhIaEdHBwcj7DJPXnypODfv3/s6OKsrKyvJSUl52HT8/XrV623b9/64rBrFw8Pz3lscs+fP0/6/fu3KIzP8u7dO4979+61Y1Osq6vrg8vRDx48aPjz5w8/ujg3N/dlXI7+8uWLAdCuDmxyLCwsn3A5GhRAQA/rwtViUzTYwaijQeD///9s1DYTHVDd0X///uWktpnoYEgkD0ZGxv/IfAAuVEODWi8cbAAAAABJRU5ErkJggg=="
            alt=""
          />&nbsp; &nbsp; Average cow acquisition cost p.a. in previous year</span
        ></span
      ></span
    ></span
  >
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 2px;
  }
</style>
